import { render, staticRenderFns } from "./OrgStaffActivity.vue?vue&type=template&id=09f837e1&"
import script from "./OrgStaffActivity.vue?vue&type=script&lang=js&"
export * from "./OrgStaffActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports